import {
    APPOINTMENT_REQUEST,
    APPOINTMENT_SUCCESS,
    APPOINTMENT_FAIL,
    APPOINTMENT_GET_ALL,
    APPOINTMENT_GET_ONE,
    APPOINTMENT_CREATE,
    APPOINTMENT_UPDATE,
    APPOINTMENT_DELETE
  } from '../actions/types';
  
  const initialState = {
    loading: false,
    error: null,
    all: [],
    one: null,
    created: null,
    updated: null,
    deletedId: null
  };
  
  export const appointmentReducer = (state = initialState, action) => {
    switch (action.type) {
      case APPOINTMENT_REQUEST:
        return { ...state, loading: true, error: null };
  
      case APPOINTMENT_CREATE:
        return { ...state, loading: false, created: action.payload };
  
      case APPOINTMENT_GET_ALL:
        return { ...state, loading: false, all: action.payload };
  
      case APPOINTMENT_GET_ONE:
        return { ...state, loading: false, one: action.payload };
  
      case APPOINTMENT_UPDATE:
        return { ...state, loading: false, updated: action.payload };
  
      case APPOINTMENT_DELETE:
        return {
          ...state,
          loading: false,
          deletedId: action.payload,
          all: state.all.filter(item => item._id !== action.payload)
        };
  
      case APPOINTMENT_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  